import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import graphqlResource from 'modules/core/graphql-resource';

// Единый baseQuery для GraphQL через существующий graphqlResource (axios + токены/заголовки)
export const graphqlBaseQuery: BaseQueryFn<
  { query: string; variables?: Record<string, any> },
  unknown,
  { status?: number; data?: any; message?: string }
> = async ({ query, variables }) => {
  try {
    const resp = await graphqlResource.query<{ data: any; errors?: { message: string }[] }>(query, variables);

    if (resp.data?.errors && resp.data.errors.length > 0) {
      const message = resp.data.errors[0]?.message || 'GraphQL error';
      return { error: { status: 400, data: resp.data.errors, message } } as any;
    }

    return { data: resp.data?.data ?? resp.data } as any;
  } catch (e: any) {
    return { error: { status: e?.response?.status, data: e?.response?.data, message: e?.message } } as any;
  }
};

// Общий API-слайс для code splitting через injectEndpoints
// reducerPath оставим коротким и универсальным
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: graphqlBaseQuery,
  // Общий набор тегов; по мере роста проекта можно расширять
  tagTypes: ['Championship', 'Team'],
  endpoints: () => ({}),
});

export default baseApi;
